module.exports = __webpack_public_path__ + "static/media/34.a29c3732.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/poinkos/34.jpg
// module id = 567
// module chunks = 0